import styled from "styled-components";
import { COLORS } from "../../../values/colors";
import LogoEckenmoorhexen from "../../../assets/images/LogoEckenmoorhexen.png";
import BurgerMenuBackground from "../../../assets/images/burgerMenu.png";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import { Tabs } from "@mui/material";
import ListItem from "@mui/material/ListItem";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";

export const NavContainer = styled.nav`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1rem 2rem;
  box-sizing: border-box;

  @media (max-width: 1199px) {
    padding: 1rem 0;
    background-color: ${COLORS.darkdarkGray};
  }
`;

export const NavInner = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 2rem;
  min-height: 5rem;

  @media (max-width: 1180px) {
    gap: 1rem;
  }

  @media (max-width: 720px) {
    gap: 0.6rem;
    min-height: 3rem;
    padding: 0 1rem;
    box-sizing: border-box;
  }
`;

export const LeftGroup = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.75rem;
  min-width: 0;
  flex: 1 1 auto;

  @media (max-width: 1180px) {
    gap: 1rem;
  }

  @media (max-width: 720px) {
    gap: 0.75rem;
  }
`;

export const CategoryNav = styled.div`
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 0.35rem;
  overflow: visible;
  padding: 0;

  @media (max-width: 1199px) {
    display: none;
  }
`;

export const CategoryTabs = styled(Tabs)`
  display: flex;
  justify-content: flex-start;
  flex: 0 1 auto;
  min-height: 0;

  .MuiTabs-flexContainer {
    align-items: center;
  }

  .MuiTabs-indicator {
    display: none;
  }
`;

export const CategoryMenu = styled.div`
  position: relative;
  flex-shrink: 0;
`;

const categoryTriggerStyles = `
  border: 0;
  border-radius: 0;
  background: transparent;
  color: rgba(255, 255, 255, 0.72);
  font-weight: 500;
  font-size: 0.92rem;
  line-height: 1.25;
  text-transform: uppercase;
  padding: 1rem 1.15rem;
  white-space: nowrap;
  cursor: pointer;
  position: relative;
  transition: opacity 0.2s ease;
  letter-spacing: 0.01em;
`;

export const ActionsGroup = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.75rem;
  flex: 0 0 auto;
  margin-left: auto;

  @media (max-width: 1199px) {
    margin-left: 0;
  }

  @media (max-width: 720px) {
    gap: 0.45rem;
  }
`;

export const CategoryPill = styled.button<{ $active: boolean }>`
  ${categoryTriggerStyles}
  flex-shrink: 0;
  color: ${({ $active }) => ($active ? COLORS.white : "rgba(255, 255, 255, 0.72)")};
  opacity: 1;

  &::after {
    content: "";
    position: absolute;
    left: 1.15rem;
    right: 1.15rem;
    bottom: 0.35rem;
    border-bottom: ${({ $active }) => ($active ? "2px solid white" : "2px solid transparent")};
  }

  &:hover {
    color: ${COLORS.white};
  }
`;

export const CategoryMenuButton = styled.button<{ $active: boolean; $open: boolean }>`
  ${categoryTriggerStyles}
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  color: ${({ $active, $open }) => ($active || $open ? COLORS.white : "rgba(255, 255, 255, 0.72)")};
  opacity: 1;

  &::before {
    content: "";
    position: absolute;
    left: 1.15rem;
    right: 1.15rem;
    bottom: 0.35rem;
    border-bottom: ${({ $active, $open }) =>
      $active || $open ? "2px solid white" : "2px solid transparent"};
  }

  &::after {
    content: "";
    width: 0.5rem;
    height: 0.5rem;
    border-right: 2px solid currentColor;
    border-bottom: 2px solid currentColor;
    transform: rotate(${({ $open }) => ($open ? "-135deg" : "45deg")});
    margin-top: ${({ $open }) => ($open ? "0.25rem" : "-0.1rem")};
    transition: transform 0.18s ease, margin-top 0.18s ease;
  }

  &:hover {
    color: ${COLORS.white};
  }
`;

export const CategoryMenuList = styled.div<{ $open: boolean }>`
  position: absolute;
  top: calc(100% + 0.75rem);
  left: 0;
  z-index: 20;
  min-width: 13rem;
  display: ${({ $open }) => ($open ? "grid" : "none")};
  gap: 0.25rem;
  padding: 0.55rem;
  background: rgba(12, 12, 12, 0.98);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 0.25rem;
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.32);

  @media (max-width: 720px) {
    position: fixed;
    top: 5.4rem;
    left: 0.75rem;
    right: 0.75rem;
    min-width: 0;
  }
`;

export const CategoryMenuItem = styled.button<{ $active: boolean }>`
  border: 0;
  background: ${({ $active }) => ($active ? "rgba(181, 115, 76, 0.2)" : "transparent")};
  color: ${COLORS.white};
  text-align: left;
  font-size: 0.95rem;
  font-weight: ${({ $active }) => ($active ? 700 : 500)};
  padding: 0.7rem 0.85rem;
  cursor: pointer;

  &:hover {
    background: rgba(255, 255, 255, 0.08);
  }
`;

export const LogoButton = styled.button`
  border: 0;
  background: transparent;
  width: 8.5rem;
  height: 5rem;
  background-image: url(${LogoEckenmoorhexen});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  cursor: pointer;
  flex-shrink: 0;
  margin-right: 0.5rem;

  @media (max-width: 720px) {
    width: 5rem;
    height: 5rem;
  }
`;

export const CartTrigger = styled.button`
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.05);
  color: ${COLORS.white};
  font-weight: 700;
  padding: 0.7rem 1rem;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  white-space: nowrap;
  min-height: 2.9rem;

  &:hover {
    background: rgba(255, 255, 255, 0.12);
  }

  @media (max-width: 720px) {
    padding: 0.62rem 0.85rem;
  }

  @media (max-width: 420px) {
    padding: 0.62rem 0.72rem;
  }
`;

export const CartInfo = styled.span`
  font-size: 0.92rem;

  @media (max-width: 560px) {
    display: none;
  }
`;

export const MobileMenuButton = styled(Button)`
  display: none;
  z-index: 3;
  min-width: auto !important;

  @media (max-width: 1199px) {
    display: inline-flex;
  }
`;

export const MobileMenuIcon = styled(MenuIcon)`
  color: white !important;
  font-size: 2.5rem !important;
`;

export const MobileDrawer = styled(Drawer)`
  .MuiDrawer-paper {
    width: 100%;
    background-color: ${COLORS.darkdarkGray};
    background-image: linear-gradient(rgba(0, 0, 0, 0.62), rgba(0, 0, 0, 0.62)), url(${BurgerMenuBackground});
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    padding-top: 1rem;
  }
`;

export const MobileDrawerHeader = styled.div`
  position: absolute;
  top: 1rem;
  right: 1rem;
  z-index: 4;
`;

export const MobileDrawerTitle = styled.p`
  display: none;
`;

export const MobileCloseButton = styled(Button)``;

export const MobileCloseIcon = styled(CloseIcon)`
  color: white !important;
  font-size: 2.5rem !important;
`;

export const MobileDrawerContent = styled.div`
  padding: 1.5rem;
`;

export const MobileCategoryList = styled(List)``;

export const MobileListItem = styled(ListItem)`
  padding: 1rem;
  color: white;

  &:hover {
    color: ${COLORS.textSecondary};
  }
`;

export const MobileCategoryButton = styled(ListItemButton)<{ $active: boolean; $open?: boolean }>`
  color: ${COLORS.white} !important;
  opacity: ${({ $active }) => ($active ? 1 : 1)};
`;

export const MobileCategoryLabel = styled(ListItemText)<{ $active: boolean }>`
  .MuiTypography-root {
    font-size: 1.5rem;
    font-weight: ${({ $active }) => ($active ? 700 : 400)};
    color: ${COLORS.white};
  }
`;

export const MobileCategoryChildren = styled.div<{ $open: boolean }>`
  display: ${({ $open }) => ($open ? "grid" : "none")};
  gap: 0;
  padding: 0 0 0 1.25rem;
`;

export const MobileCategoryChildButton = styled(ListItemButton)<{ $active: boolean }>`
  color: ${COLORS.white} !important;
`;

export const MobileCategoryChildLabel = styled(ListItemText)<{ $active: boolean }>`
  .MuiTypography-root {
    font-size: 1.2rem;
    font-weight: ${({ $active }) => ($active ? 700 : 400)};
    color: ${COLORS.white};
  }
`;

